import React, { useState, useEffect } from 'react';
import Field from '../../Field/Field'
import { MAIN_CONFIG } from '../../../../config/main'
import DrawnArrow from '../../SVG/DrawnArrow'
import { getQuestionDataType } from '../../../Utility/RecommendationDataTypeMapping';
import { parseHtml, formatAnswerOptions, renderQuestionLabelWithAsterisk } from '../../../Utility/HelperFunctions';
import { getAnswer, findLabel, readOnly, readOnlyWihtoutLogin, allowApplicantUploadsAfterDeadlineFunction, skipConfigIds, skipConfigValue, handleKeyDown, getPlaceholder } from '../../../Utility/ApplicationFormUtility';
import { isEmpty, uniq } from 'lodash';
import CTAButton from '../../../Components/CTAButton/CTAButton';
import Pencil from '../../../Components/SVG/Pencil';
import Trash from '../../../Components/SVG/Trash';
import Add from '../../../Components/SVG/Add';
import cookies from 'next-cookies';
import Success from '../../SVG/Success';
import Warning from '../../SVG/Warning';
import './application-section.scss'
import Plus from '../../SVG/Plus';
import Preview from '../../SVG/Preview';

/**
 * Application form section
 *
 * @param {object} props
 * @param {'references' | ''} props.type
 * @param {string} props.title
 * @param {object[]} props.questions
 * @param {string[]} props.references
 * @param {boolean} props.isLast
 *
 * @returns {ReactElement}
 */

export default ({
  type = false,
  title = '',
  subTitle = '',
  herokuRoleDisplayName = '',
  questions = [],
  isLast = false,
  errors = [],
  onChange = () => { },
  deleteApplicationDocument = () => { },
  showRecommenderModal = () => { },
  handleRecommenderRemove = () => { },
  referencesList = [],
  referenceButtonShow = false,
  step = false,
  iteratableStepShowFirst = false,
  showIterationModal = () => { },
  handleIterationRemove = () => { },
  iterationList = [],
  iterationfield = [],
  iterationButton = false,
  iterationCount = 0,
  iterationLabel,
  handleClickShowTearmsCondictionModal = () => { },
  agreementResponse = () => { },
  externalRoleList = [],
  showExtraIterationModal = () => { },
  handleExtraIterationRemove = () => { },
  externalButton = false,
  maximumRecord = '',
  setModalState = () => { },
  emailConfimation,
  emailConfimationErrors,
  handleEmailConfirmation,
  onSuggestiveSelect = () => { },
  onQuestionSuggestiveSelect = () => { },
  handleAddressSelection = () => { },
  handleClickOnDocuSignShow = () => { },
  handleClickEsignShow = () => { },
  buttonSecondaryColor,
  allowApplicantUploadsAfterDeadline = false,
  dependentConfigsForVariousSteps = [],
  onBlur = () => { },
  isOpenPassword = false,
  handleSetPassword = () => { },
  passwordError = {},
  password = '',
  thirteenYearAge = '',
  setThirteenYearAge = {},
  applicationId,
  handleClearEncryptedValue,
  ...props
}) => {

  const userContext = cookies('context').context
  const [
    state,
    setState,
  ] = useState({
    isActive: false,
    isCompleted: false,
  })


  const toggle = () => {
    setState(previousState => {
      return {
        ...previousState,
        isActive: !previousState.isActive,
      }
    })
  }

  const close = () => {
    setState({
      isActive: false,
      isCompleted: true,
    })
  }

  const handleDocumentVisibility = (record = {}) => {
    let isVisible = (record.doc_upload_required__c || getQuestionDataType(record.data_type__c) === "Document")
    return isVisible && ((record.maximum_doc_upload_required__c ? (record.maximum_doc_upload_required__c <= (record.document ? record.document.length : 0)) : false))
  }

  const handleShowError = (id) => {
    var message = ""
    if (errors.length > 0) {
      errors.map((item) => {
        if (id === item.id) {
          message = item.message
        }
      })
      return message
    }
    return null
  }

  const MultiLevelPiclistData = (fieldObj, answer) => {
    const picklistDep = (fieldObj.answer_options__c || '').split(/\r?\n/)
    let answerObj = {}
    picklistDep.map(val => {
      let values = val.split(';')
      const key = values.splice(0, 1)
      values = values.filter(val => !isEmpty(val))
      answerObj[key[0]] = values
      return null
    })

    let configVal = {
      title: answer ? answer : (fieldObj.answer ? fieldObj.answer : 'Choose an option')
    };

    const getSubMenu = (title) => {
      return {
        'title': title,
        'subMenu': null
      }
    }

    const configSubMenus = Object.keys(answerObj).map((key, index) => {
      const subMenus = answerObj[key].map(k => {
        return getSubMenu(k)
      })
      return {
        'title': key,
        'submenu': subMenus
      }
    })

    configVal['submenu'] = configSubMenus

    return [configVal]
  }


  // Answer dependent picklist
  const answerDependentOptions = (fieldObj, question) => {
    const parentVals = question.parent_picklist__c.split(';');
    const parentObj = questions.filter(obj => { return parentVals.includes(obj.name.toString()) })
    let answersToRemove = []
    parentObj.map(parent => {
      if (parent.answer) {
        const parentAns = parent.answer
        if (parent.data_type__c === "Multiselect Picklist") {
          const ansVal = Array.isArray(parentAns) ? parentAns : parentAns.split(';')
          ansVal.map(a => answersToRemove.push(a))
        } else {
          answersToRemove.push(parentAns)
        }
      }
      return null
    })


    const fieldOptions = (question.answer_options__c.split(';'))
    let finalOptions = []
    if (fieldOptions.length > 0) {
      fieldOptions.map(opt => {
        if (answersToRemove.indexOf(opt) < 0) {
          finalOptions.push(opt)
        }
        return null
      })
    }
    if ((question.answer) && (finalOptions.indexOf((question.answer)) < 0)) {
      onChange(question.id, "")
    }

    return formatAnswerOptions(finalOptions.join(";"))
  }

  // dependent picklist
  const dependentPicklistOptions = (question) => {
    const parentObj = questions.find(obj => { return obj.sfid.toString() === question.parent_picklist_config__c })
    if (parentObj) {
      const parentAns = (parentObj.answer)
      const picklistDep = question.picklist_dependency__c.split(/\r?\n/)
      let anserOptions = "";
      let options = [];
      if (parentObj.data_type__c === "Multiselect Picklist") {
        const ansVal = Array.isArray(parentAns) ? parentAns : (parentAns || '').split(';')
        let multipleOptions = [];
        ansVal.map((val) => {
          anserOptions = questions.find(obj => { return obj.sfid.toString() === question.parent_picklist_config__c })
          picklistDep.find(obj => { return obj.split(';')[0] === val }) || ''
          multipleOptions = multipleOptions.concat(anserOptions.split(';'))
          multipleOptions = multipleOptions.filter(function (el) {
            return !(el === val)
          });
          return null
        })
        options = uniq(multipleOptions);
      } else {
        anserOptions = picklistDep.find(obj => { return obj.split(';')[0] === parentAns }) || ''
        let optionsingle = anserOptions.split(';')

        let count = 0
        optionsingle.map(function (el) {
          if (el === parentAns) {
            count = count + 1
          }
        });
        if (count > 1) {
          options = uniq(optionsingle);
        } else {
          options = optionsingle.filter(function (el) {
            return !(el === parentAns)
          });
        }

      }
      options = options.filter(function (el) {
        return !isEmpty(el)
      });
      return formatAnswerOptions(options.join(";"))
    } else {
      return []
    }
  }

  const handleCheckCheckbox = (e, value) => {
    handleClickShowTearmsCondictionModal(e, value)
  }

  const onDocuSignShow = (e) => {
    handleClickOnDocuSignShow(e)
  }

  const isEsignChange = (e, val) => {
    handleClickEsignShow(e, val)
  }

  const optionMultiSelect = (question) => {
    const parentObj = questions.find(obj => { return obj.sfid.toString() === question.parent_picklist_config__c })
    if (parentObj) {
      const parentAns = (parentObj.answer)
      const picklistDep = question.picklist_dependency__c.split(/\r?\n/)
      let anserOptions = "";
      let options = [];
      if (parentObj.data_type__c === "Multiselect Picklist") {
        const ansVal = Array.isArray(parentAns) ? parentAns : (parentAns || '').split(';')
        var multipleOptions = [];
        let dependOption = [];
        ansVal.map((val) => {
          anserOptions = picklistDep.find(obj => { return obj.split(';')[0] === val }) || ''
          let multipleOption = multipleOptions.concat(anserOptions.split(';'))
          // multipleOptions = multipleOptions.filter(function (el) {
          //   return !(el === val)
          // });
          let count = 0
          multipleOption.map(function (el) {
            if (el === val) {
              count = count + 1
            }
          });
          if (count > 1) {
            multipleOption = uniq(multipleOption)
          } else {
            multipleOption = multipleOption.filter(function (el) {
              return (el !== val)
            });
          }
          multipleOptions.push(...multipleOption)
          return null
        })
        let newMultipleOption = []
        newMultipleOption = uniq(multipleOptions)
        options = newMultipleOption.filter(function (el) {
          return !isEmpty(el)
        });
        return formatAnswerOptions(options.join(";"))
      }
    } else {
      return []
    }
  }

  const handleMultiSelectDependentPicklist = (question) => {
    const dataAry = question.dependent_answer_options__c ? optionMultiSelect(question) : question.answer_options__c.split(';')
    return dataAry;
  }

  let arr = JSON.parse(localStorage.getItem('hasAccessCode'))

  const handleRemove = (e,callBack) => {
    if (arr?.includes(applicationId) || !allowApplicantUploadsAfterDeadline) {
      callBack()
    }
  }

  const showModalType = (e,callBack) => {
    e.preventDefault()
    if (arr?.includes(applicationId) || !allowApplicantUploadsAfterDeadline) {
     callBack()
    }
  }
const getIterationCount=(count)=>{
  return count
}

  const renderStrenghtCheckMessage = (showSuccess) => {
    if(showSuccess){
      return <Success color={MAIN_CONFIG.COLORS.fillGreen} iconColor={MAIN_CONFIG.COLORS.fillWhite} />
    } else {
      return <Warning />
    }
  }

  const handleMinMaxCheck = (exitConfig, value) => exitConfig ? "" : value;

  const isFieldRequired = (question) => {
    return question.required__c || (question.minimum_word_required__c && question.word_count_enable__c);
  };

  const getFieldOptions = (question) => {
    if (question.data_type__c === "Answer Dependent Picklist") {
      return answerDependentOptions(question.answer_options__c || '', question);
    } else if (question.data_type__c === "Dependent Picklist") {
      return dependentPicklistOptions(question);
    } else if (question.dependent_answer_options__c) {
      return handleMultiSelectDependentPicklist(question);
    } else {
      return formatAnswerOptions(question.answer_options__c || '', question.data_type__c);
    }
  };

  const getFieldValue = (question) => {
    if(question.data_type__c === 'Iteration Count'){
      return getIterationCount(iterationCount)
    } else {
      return getAnswer(question)
    }
  }

  const renderClearButtonSection = (question) => {
    const clearInputDataTypes = ['Number', 'Text', 'Long Text']
    return (
      question.encryptable__c && question.is_encrypted && clearInputDataTypes.includes(question.data_type__c) && 
      <span className='encrypted-pencil-icon' onClick={(e) => handleClearEncryptedValue(e, question.id)}>
        <Pencil color={MAIN_CONFIG.COLORS.fillBlue} width="20" height="20" ariaLabel="Edit" ariaLabelDescription="Edit" />
      </span>
    );
  };

  /**
   * Render Application Question Input
   * @returns {JSX.Element}
   */
  const renderApplicationInput = () => questions.map((question) => {
      return (
      <>
        <div className="application-section__question" key={question.sfid}>
          <Field
            label={renderQuestionLabelWithAsterisk(question)}
            ariaLabel={question.label__c}
            id={question.id}
            labelClassName="application-field-label-style"
            className="application-section__textarea"
            max_video_length_in_seconds__c={question.max_video_length_in_seconds__c}
            min_video_length_in_seconds__c={question.min_video_length_in_seconds__c}
            minNumber={handleMinMaxCheck(question.exit_config__c, question.min_value__c)}
            maxNumber={handleMinMaxCheck(question.exit_config__c, question.max_value__c)}
            minDateFilter={handleMinMaxCheck(question.exit_config__c, question.min_date__c)}
            maxDateFilter={handleMinMaxCheck(question.exit_config__c, question.max_date__c)}
            dateFormat={question.data_type__c}
            maxLengthInput={question.number_input_required_max_length__c ? question.number_input_required_max_length__c : null}
            multiLevelPiclistData={() => MultiLevelPiclistData(question, question.answer)}
            multiLevelQeustion={question}
            description={parseHtml(question.description__c)}
            errorMsg={handleShowError(question.id)}
            placeholder={getPlaceholder(question.data_type__c)}
            options={getFieldOptions(question)}
            type={getQuestionDataType(question.data_type__c == 'Number' && question.encryptable__c ? 'Encrypted Number'  : question.data_type__c)}
            value={getFieldValue(question)}
            isNotShowingFutureDate={question.salesforce_field_value__c && question.salesforce_field_value__c.includes("Application__c.Date_of_Birth__c")}
            required={isFieldRequired(question)}
            onChangeRemoveSet={true}
            has_document={question.doc_upload_required__c}
            documentHide={handleDocumentVisibility(question)}

            handleChange={(value, videoDuration) => onChange(question.id, value, videoDuration)}

            onHandleBlur={(value) => (userContext != 'APPLICANT' && getQuestionDataType(question.data_type__c) == "email" && question.salesforce_field_value__c && question.salesforce_field_value__c.includes("Application__c.Email_Address__c")) ? onBlur(question.id, value) : (userContext === 'APPLICANT')?onChange(question.id, value):""}

            // isPaste={getQuestionDataType(question.data_type__c) == "email" ? true : false}

            videoLable={findLabel(question)}
            disabled={userContext == 'APPLICANT' ? arr?.includes(applicationId) ? readOnly(question, step) ? true : false : allowApplicantUploadsAfterDeadline ? allowApplicantUploadsAfterDeadlineFunction(getQuestionDataType(question.data_type__c), question.doc_upload_required__c) : readOnly(question, step) : readOnlyWihtoutLogin(question, step)}
            minWordCountLongText={question.minimum_word_required__c ? question.minimum_word_required__c : question.word_count_enable__c ? true : false}

            // charLimit={question.word_count_enable__c && question.data_type__c === 'Long Text' ? question.word_count__c ? question.word_count__c : 25000  : question.word_count__c || 2500}
            charLimit={question.data_type__c === 'Long Text' ? question.word_count_enable__c ? question.word_count__c ? question.word_count__c : 25000 : 25000 : 255}
            onbordingBirthdayDatefilter={question.salesforce_field_value__c && question.salesforce_field_value__c.includes("Application__c.Date_of_Birth__c")}
            createPicklist={(question.data_type__c === "Picklist" && question.auto_suggest__c)}
            autoSuggest={question.data_type__c !== "Picklist" && question.auto_suggest__c}
            autoSuggestData={question.auto_suggest_data__c}
            suggestionData={question}
            onSuggestiveSelect={onSuggestiveSelect}
            onQuestionSuggestiveSelect={onQuestionSuggestiveSelect}
            allQuestionsData={questions}

            isAgrementChange={handleCheckCheckbox}
            onDocuSignShow={onDocuSignShow}
            isEsignChange={isEsignChange}
            addressAutoSuggestData={question.address_auto_suggest__c}
            handleAddressSelection={handleAddressSelection}

            allowApplicantUploadsAfterDeadline={arr?.includes(applicationId) ? true : allowApplicantUploadsAfterDeadline && question.doc_upload_required__c || false}
            newtheme={true}
            allowHtmlTags={["Long Text", "Text"].includes(question.data_type__c)}
            currencyName={question?.currency_symbol__c || 'USD'}
            questionData={question}
          />
          {renderClearButtonSection(question)}
          {question.document && question.document.length > 0 &&
            question.document.map(doc =>
              <Field
                id={doc.sfid || doc.heroku_id__c}
                className="application-section__textarea"
                labelClassName="application-field-label-style"
                type={'Document'}
                value={doc}
                uploadedDocument={doc}
                handleDocumentDelete={(doc) => deleteApplicationDocument(doc)}
                newtheme={true}
              />
            )
          }

        </div>

        {isOpenPassword && question.config_type__c === "Field" && question.data_type__c === "Email" && (question.salesforce_field_value__c.includes("Application__c.Email_Address__c")) &&
          <>
            <div className="application-section__question" key={question.sfid}>
              <Field
                label="Email Confirmation"
                id={question.sfid}
                className="application-section__textarea"
                labelClassName="application-field-label-style"
                type="email"
                placeholder='Email Confirmation'
                handleChange={(value) => handleEmailConfirmation(question.answer, value)}
                required={true}
                isPaste={true}
                errorMsg={emailConfimationErrors}
                newtheme={true}
              />
            </div>

            <div className="application-section__question" key={question.sfid}>
              <Field
                id={question.sfid}
                label="Set a Password"
                placeholder="Set a Password"
                className="application-section__textarea"
                labelClassName="application-field-label-style"
                type={'password'}
                handleChange={(value) => handleSetPassword(value)}
                newtheme={true}
              />
            </div>
            {
              password &&
              <div className="form-group" style={{marginTop: '15px'}}>
                <div className="password-policy-list">
                  <ul className="list-items">
                    <li className="BodyDefault">{renderStrenghtCheckMessage(passwordError.hasSymbol)} MUST contain at least one special character ( ! " # $ % ^ & * ( ) _ - + = ` ~ \ /)</li>
                    <li className="BodyDefault">{renderStrenghtCheckMessage(passwordError.hasUpperCase)} MUST contain at least one uppercase letter</li>
                    <li className="BodyDefault">{renderStrenghtCheckMessage(passwordError.hasLowerCase)} MUST contain at least one lowercase letter</li>
                    <li className="BodyDefault">{renderStrenghtCheckMessage(passwordError.hasNumber)} MUST contain at least one number</li>
                    <li className="BodyDefault">{renderStrenghtCheckMessage(passwordError.hasLength)} MUST contain at least 10 characters (12+ recommended)</li>
                  </ul>
                </div>
              </div>
            }
            <div className="application-section__question i-confirm-and-i-agree" key={question.sfid}>
              <input
                className="application-section__textarea"
                type="checkbox"
                onChange={(e) => setThirteenYearAge(e.target.checked)}
                checked={thirteenYearAge}
              />
                <span className='BodyDefaultBoldBlack'><div className='i-confirm-that-i-am'>I confirm that I am:</div>
                 <div>at least 13 years old in the United States or any other country, or</div>
                 <div>at least 18 years old in Mexico, Turkey or South Africa</div>
                 <div className='confirm-and-agree'>and agree to Kaleidoscope’s <a href="https://www.mykaleidoscope.com/terms-of-use" target="_blank">Terms</a> and <a href="https://www.mykaleidoscope.com/privacy-policy" target="_blank">Privacy Policy</a>.
                 </div> 
                </span>
            </div>
          </>
        }
      </>
    )
  })
  return (
    <fieldset
      className={`
        application__form-section
        application-section
        ${isLast ? 'application-section--last' : ''}
        ${state.isActive ? 'is-active' : ''}
        ${state.isCompleted ? 'is-completed' : ''}
      `}
    >
      <legend className="application-section__title application-section__title-section-mobile">
        {parseHtml(title)}
        {parseHtml(subTitle) && <small className="application-section__subtitle">{parseHtml(subTitle)}</small>}
      </legend>

      <div className="application-section__content">
        <div className="application-section__mobile-top">
          <button
            className="application-section__mobile-back"
            onClick={close}
            type="button"
          >
            <DrawnArrow className="application-section__mobile-back-icon" />
            Back
          </button>
        </div>


        {!iteratableStepShowFirst &&
          renderApplicationInput()
        }

        {referenceButtonShow &&
          referencesList.length > 0 && referencesList.map((row, index) => {
            return <div className="application-review-attachment" key={row.id}>
            <div className="application-review-attachment__main">
                { userContext !== 'APPLICANT' ? 
                <>
                  <h4 className="application-review-attachment__heading">
                  {row.first_name + ' ' + row.last_name}
                  </h4>
                  <small className="application-review-attachment__small">
                    {row.email}
                  </small>
                  <small className="application-review-attachment__small">
                    {row.relationship}
                  </small>
                </>
                : <div type="primary" className="outline border flat edit-user__btn" onClick={(e) => showRecommenderModal(e, iterationList.added_questions.length > 0 && iterationList.added_questions[index], row, 'view rec')}>
                  {row.first_name + ' ' + row.last_name }
                </div>}
                
              </div>
              <div className="application-review-attachment__trigger-view-file">
                <div className="edit-delete-icon-container" >
                  <span tabIndex={0} onKeyDown={(e)=>handleKeyDown(e,() => showRecommenderModal(e, iterationList.added_questions.length > 0 && iterationList.added_questions[index], row, 'edit'))} className="edit-delete-icon-container__edit-btn 1" onClick={(e) => showRecommenderModal(e, iterationList.added_questions.length > 0 && iterationList.added_questions[index], row, 'view rec')}><Preview color={MAIN_CONFIG.COLORS.fillBlue} width={24} height={24} ariaLabel={"view"} ariaLabelDescription = "view record"/></span>
                  <span tabIndex={0} role='button' onKeyDown={(e)=>handleKeyDown(e,()=>handleRemove(e,()=>handleRecommenderRemove(e, row.id)))} className="edit-delete-icon-container__delete-btn 1" onClick={(e) => handleRemove(e,()=>handleRecommenderRemove(e, row.id))}><Trash color={MAIN_CONFIG.COLORS.fillRed} width="24" height="24" ariaLabel="Delete" ariaLabelDescription="Delete" /></span>
                </div>
              </div>
            </div>
          })
        }

        {referenceButtonShow && (maximumRecord ? maximumRecord !== referencesList.length : true) &&
          <div className="add-recommender-with-question-btn-container">
            <div tabIndex={-1} onClick={(e) =>showModalType(e,()=>showRecommenderModal(e, [], '', 'new'))} onKeyDown={(e)=>handleKeyDown(e,()=>showModalType(e,()=>showRecommenderModal(e, [], '', 'new')))} className="icon-with-role-label">
              { userContext !== 'APPLICANT' ? <div>
                <Add className="add-recommender-with-question-btn-container__icon" width="70" height="70" ariaLabel="Add" ariaLabelDescription="Add" />
              </div> : <CTAButton type="primary" id="primary-btn" className="outline border flat">
                  <Plus />
                    {herokuRoleDisplayName ? herokuRoleDisplayName : 'Add Recommender'}
                </CTAButton>}
            </div>
          </div>
        }

        {externalButton &&
          externalRoleList.length > 0 && externalRoleList.map((iteration, index) => {
            iteration.sort(function (a, b) {
              return a.order__c - b.order__c;
            });

            let removeDataArg = iteration.filter((row) => { if (row.config_type__c === 'Field') { return row } })
            let removeData = removeDataArg[0].financial_information_id

            return <div className="application-review-attachment" key={iteration[0].id}>
              <div className="application-review-attachment__main">
                <h4 className="application-review-attachment__heading">
                  { userContext !== 'APPLICANT'? iteration[0].answer
                : <CTAButton type="primary" id="primary-btn" className="outline border flat">
                {/* <Edit /> */}
                {iteration[0].answer}
              </CTAButton>}
                
                </h4>
                {userContext !== 'APPLICANT' && iteration.length > 1 &&
                  <small className="application-review-attachment__small">
                    {iteration[1].answer}
                  </small>
                }
              </div>
              <div className="application-review-attachment__trigger-view-file">
                <div className="edit-delete-icon-container" >
                  <span tabIndex={0} className="edit-delete-icon-container__edit-btn 2" role='button' onKeyDown={(e)=>handleKeyDown(e,()=>showExtraIterationModal(e, iterationfield, 'edit'))} onClick={(e) => showExtraIterationModal(e, iteration, 'edit')}><Pencil color={MAIN_CONFIG.COLORS.fillBlue} width="24" height="24" ariaLabel="Edit" ariaLabelDescription="Edit" /></span>
                  <span tabIndex={0} className="edit-delete-icon-container__delete-btn 2" role='button' onKeyDown={(e)=>handleKeyDown(e,()=>handleRemove(e,()=>!allowApplicantUploadsAfterDeadline && handleExtraIterationRemove(e, removeData)))}  onClick={(e) => !allowApplicantUploadsAfterDeadline && handleExtraIterationRemove(e, removeData)}><Trash color={MAIN_CONFIG.COLORS.fillRed} width="24" height="24" ariaLabel="Delete" ariaLabelDescription="Delete" /></span>
                </div>
              </div>
            </div>
          })
        }

        {externalButton && (maximumRecord ? maximumRecord !== externalRoleList.length : true) &&
          <div className="add-recommender-with-question-btn-container">
            <div tabIndex={-1} role='button'  onKeyDown={(e)=>handleKeyDown(e,()=>showExtraIterationModal(e, iterationfield, 'new'))} onClick={(e)=>showModalType(e,()=>showExtraIterationModal(e, iterationfield, 'new'))} className="icon-with-role-label">
              {userContext !== 'APPLICANT' ? <div>
                <Add className="add-recommender-with-question-btn-container__icon" width="70" height="70" ariaLabel="Add" ariaLabelDescription="Add" />
              </div>: <CTAButton type="primary" id="primary-btn" className="outline border flat" >
                  <Plus />
                  {herokuRoleDisplayName ? herokuRoleDisplayName : 'Add Recommender'}
                </CTAButton>}
            </div>
          </div>
        }




        {/* <Divider solid={ true }  className="application-steps-divider-line"/>  */}

        {iterationButton &&
          !isEmpty(iterationList) && !isEmpty(iterationList.added_questions) && iterationList.added_questions.map((iteration, index) => {
            let skipConfigIdField = skipConfigIds(iteration, questions.concat(dependentConfigsForVariousSteps || []) || [])
            let skipConfigValueField = skipConfigValue(skipConfigIdField, questions.concat(dependentConfigsForVariousSteps || []) || [])
            skipConfigValueField.filter(question => {
              question.answer = (['Date(Date-Month-Year)', 'Date', 'Date(Month-Date-Year)'].includes(question.data_type__c)) ? (question.answer || question.default_day_for_date__c) : question.answer || ''
            })

            return <div className="application-review-attachment" key={skipConfigValueField[0].id}>
              <div className="application-review-attachment__main"  id='application-review-attachment__main-app'>
                <h4 className="application-review-attachment__heading">
                { userContext !== 'APPLICANT'? <pre>{skipConfigValueField[0].answer}</pre>
                : <div  className="outline border flat edit-user__btn" >
                {skipConfigValueField[0].answer}
              </div>}
                  
                </h4>
                { userContext !== 'APPLICANT' && skipConfigValueField.length > 1 &&
                  <small className="application-review-attachment__small">
                    <pre>{skipConfigValueField[1].answer}</pre>
                  </small>
                }
              </div>
              <div className="application-review-attachment__trigger-view-file">
                <div className="edit-delete-icon-container" >
                  <span tabIndex={0} className="edit-delete-icon-container__edit-btn 3" onKeyDown={(e)=>handleKeyDown(e,()=>showIterationModal(e, iteration, 'edit'))} onClick={(e) => showIterationModal(e, iteration, 'edit')}><Pencil color={MAIN_CONFIG.COLORS.fillBlue} width="24" height="24" ariaLabel="Edit" ariaLabelDescription="Edit" /></span>
                  <span tabIndex={0} role='button' onKeyDown={(e)=>handleKeyDown(e,()=>handleRemove(e,()=>handleIterationRemove(e, iteration[0].question_set_number)))}  className="edit-delete-icon-container__delete-btn 3" onClick={(e)=>handleRemove(e,()=>handleIterationRemove(e, iteration[0].question_set_number))}><Trash color={MAIN_CONFIG.COLORS.fillRed} width="24" height="24" ariaLabel="Delete" ariaLabelDescription="Delete" /></span>
                </div>
              </div>
            </div>
          })
        }
        {iterationButton && (maximumRecord ? maximumRecord > iterationCount : true) &&
          <div className="add-recommender-with-question-btn-container">
            <CTAButton
              id="primary-btn" 
              className="outline border flat"
              onClick={(e) =>showModalType(e,()=>showIterationModal(e, iterationfield, 'new'))}
              type="primary"
            > <Plus />
              {iterationLabel}
            </CTAButton>
          </div>
        }
        {iteratableStepShowFirst &&
          renderApplicationInput()
        }
        {/* <div className="application-section__mobile-done-wrapper">
          <button
            className="application-section__mobile-done"
            onClick={close}
            type="button"
          >
            Done
          </button>
        </div> */}
      </div>
    </fieldset>
  )
}
